import {createAction, props} from '@ngrx/store';
import {PaginatedIndustries, Industry } from '@app/modules/shared/models/industries';

enum EIndustriesActions {
  IndustriesList = '[Industries] Industries List',
  IndustriesListSuccess = '[Industries] Industries List Success',
  IndustriesListError = '[Industries] Industries List Error',
  IndustryCreate = '[Industries] Industry Create',
  IndustryCreateSuccess = '[Industries] Industry Create Success',
  IndustryCreateError = '[Industries] Industry Create Error',
  IndustryUpdate = '[Industries] Industry Update',
  IndustryUpdateSuccess = '[Industries] Industry Update Success',
  IndustryUpdateError = '[Industries] Industry Update Error',
  IndustryDelete = '[Industries] Industry Delete',
  IndustryDeleteSuccess = '[Industries] Industry Delete Success',
  IndustryDeleteError = '[Industries] Industry Delete Error',

  ResetIndustriesState = '[Industries] Reset Industries State',
}

export const IndustriesList = createAction(EIndustriesActions.IndustriesList, props<{ params: any }>());
export const IndustriesListSuccess = createAction(EIndustriesActions.IndustriesListSuccess, props<{ paginatedIndustries: PaginatedIndustries }>());
export const IndustriesListError = createAction(EIndustriesActions.IndustriesListError, props<{ error: string }>());

export const IndustryCreate = createAction(EIndustriesActions.IndustryCreate, props<{ industry: Partial<Industry> }>());
export const IndustryCreateSuccess = createAction(EIndustriesActions.IndustryCreateSuccess);
export const IndustryCreateError = createAction(EIndustriesActions.IndustryCreateError, props<{ error: string }>());

export const IndustryUpdate = createAction(EIndustriesActions.IndustryUpdate, props<{ industryId: number; industry: Partial<Industry> }>());
export const IndustryUpdateSuccess = createAction(EIndustriesActions.IndustryUpdateSuccess);
export const IndustryUpdateError = createAction(EIndustriesActions.IndustryUpdateError, props<{ error: string }>());

export const IndustryDelete = createAction(EIndustriesActions.IndustryDelete, props<{ industryId: number }>());
export const IndustryDeleteSuccess = createAction(EIndustriesActions.IndustryDeleteSuccess);
export const IndustryDeleteError = createAction(EIndustriesActions.IndustryDeleteError, props<{ error: string }>());

export const ResetIndustriesState = createAction(EIndustriesActions.ResetIndustriesState, (params: any = {}) => params);
